import Login from "../../application/login/Login";

export default function LoginCustomer() {
    return (
        <Login />
    )
}